"use client";
import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { AppRouterCacheProvider } from "@mui/material-nextjs/v16-appRouter";
import { persistor, store } from "./store";
import { ThemeSettings } from "@/utils/theme/Theme";
import "@/utils/i18n";
import { usePathname } from "next/navigation";

const ThemeProviderWrapper = ({ children }) => {
  const theme = ThemeSettings();
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
export function Providers({ children }) {
  const pathname = usePathname();
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
            refetchOnWindowFocus: false,
            retry: 1,
          },
        },
      }),
  );

  return (
    <AppRouterCacheProvider options={{ key: "css", prepend: true }}>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          {pathname === "/login" ? (
            <ThemeProviderWrapper>
              <CssBaseline />
              {children}
            </ThemeProviderWrapper>
          ) : (
            <PersistGate loading={null} persistor={persistor}>
              <ThemeProviderWrapper>
                <CssBaseline />
                {children}
              </ThemeProviderWrapper>
            </PersistGate>
          )}
        </Provider>
      </QueryClientProvider>
    </AppRouterCacheProvider>
  );
}
